import { render, staticRenderFns } from "./staffDetails.vue?vue&type=template&id=43a5a4c5&scoped=true&"
import script from "./staffDetails.vue?vue&type=script&lang=js&"
export * from "./staffDetails.vue?vue&type=script&lang=js&"
import style0 from "./staffDetails.vue?vue&type=style&index=0&id=43a5a4c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a5a4c5",
  null
  
)

export default component.exports